/**
 * S3 Bucket Names
 * Centralized enum for all S3 buckets used in the application
 */
export enum S3Bucket {
  ASSETS_DESYGNER = 'assets.desygner.com',
  ASSETS_FLUER = 'assets.fluer.com',
  ASSETS_INKIVE = 'assets.inkive.com',
  ASSETS_KNOWZ = 'assets.knowz.com',
  ASSETS_WEBRAND = 'assets.webrand.com',
  CALIFORNIA_INKIVE = 'california.inkive.com',
  DEMO_FLUER_DOCUMENT_EDITOR = 'demo-fluer-document-editor-1',
  FLUER_AI_GENERATED_MEDIA = 'prod-fluer-ai-generated-media',
  FLUER_ASSETS = 'com.fluer.assets',
  FLUER_CONTENT = 'com.fluer.content',
  FLUER_DEV_AI_GENERATED_MEDIA = 'dev-fluer-ai-generated-media',
  FLUER_DEV_ASSETS = 'com.fluer.dev.assets',
  FLUER_DEV_CONTENT = 'com.fluer.dev.content',
  FLUER_DEV_DOCUMENT = 'com.fluer.dev.document',
  FLUER_DEV_UPLOADS = 'com.fluer.dev.uploads',
  FLUER_DEV_VERSION = 'com.fluer.dev.version',
  FLUER_DOCUMENT = 'com.fluer.document',
  FLUER_DOCUMENT_EDITOR = 'fluer-document-editor',
  FLUER_EDITOR = 'fluer-editor',
  FLUER_UPLOADS = 'com.fluer.uploads',
  FLUER_VERSION = 'com.fluer.version',
  GILES_PHOTODEXIA = 'giles.photodexia.com',
  IRELAND_INKIVE = 'ireland.inkive.com',
  MAINTENANCE_WEBSITE = 'maintenance-website.desygner.com',
  OREGON_INKIVE = 'oregon.inkive.com',
  SAO_PAULO_INKIVE = 'sao-paulo.inkive.com',
  SG_INVENTORY = 'sg-inventory',
  SINGAPORE_INKIVE = 'singapore.inkive.com',
  STATIC_BUILD_FLUER = 'static.build.fluer.com',
  STATIC_DEV_FLUER = 'static.dev.fluer.com',
  STATIC_FLUER = 'static.fluer.com',
  SYDNEY_INKIVE = 'sydney.inkive.com',
  TOKYO_INKIVE = 'tokyo.inkive.com',
  VIRGINIA_INKIVE = 'virginia.inkive.com',
  VIRGINIA_TESTING_WEBRAND = 'virginia-testing.webrand.com',
  VIRGINIA_WEBRAND = 'virginia.webrand.com',
  WORKSPACE_DESYGNER = 'com-desygner-workspace',
  WORKSPACE_DESYGNER_APP = 'com-desygnerapp-workspace',
}

/**
 * CDN Domain URLs
 * Centralized enum for all CDN domains used in the application
 */
export enum CdnDomain {
  AI_MEDIA_DEV_FLUER = 'ai-media.dev.fluer.com',
  AI_MEDIA_FLUER = 'ai-media.fluer.com',
  ASSETS_FLUER = 'assets.fluer.com',
  ASSETS_KNOWZ = 'assets.knowz.com',
  CDN_BUILD_DESYGNER = 'cdn.builddesygner.xyz',
  CDN_DESYGNER = 'cdn.desygner.com',
  CONTENT_DEV_FLUER = 'content.dev.fluer.com',
  CONTENT_FLUER = 'content.fluer.com',
  DOCS_DEV_FLUER = 'docs.dev.fluer.com',
  DOCS_FLUER = 'docs.fluer.com',
  DOCUMENT_DEV_FLUER = 'document.dev.fluer.com',
  FLUER_COM = 'fluer.com',
  HTML_EDITOR_BUILD_DESYGNER = 'html-editor.builddesygner.xyz',
  HTML_EDITOR_DESYGNER = 'html-editor.desygner.com',
  HTML_EDITOR_MAKE_DESYGNER = 'html-editor.makedesygner.xyz',
  MEDIA_DEV_FLUER = 'media.dev.fluer.com',
  MEDIA_FLUER = 'media.fluer.com',
  STATIC_BUILD_DESYGNER = 'static.builddesygner.xyz',
  STATIC_BUILD_FLUER = 'static.build.fluer.com',
  STATIC_BUILD_WEBRAND = 'static.buildwebrand.xyz',
  STATIC_DESYGNER = 'static.desygner.com',
  STATIC_DEV_FLUER = 'static.dev.fluer.com',
  STATIC_FLUER = 'static.fluer.com',
  STATIC_INKIVE_COM = 'static.inkive.com',
  STATIC_INKIVE_ME = 'static.inkive.me',
  STATIC_MAKE_DESYGNER = 'static.makedesygner.xyz',
  STATIC_MAKE_WEBRAND = 'static.makewebrand.xyz',
  STATIC_PHOTODEXIA = 'static.photodexia.com',
  STATIC_QA_DESYGNER = 'static.qadesygner.xyz',
  STATIC_QA_WEBRAND = 'static.qawebrand.xyz',
  STATIC_WEBRAND = 'static.webrand.com',
  STATIC_WL_WEBRAND = 'static-wl.webrand.com',
  UPLOADS_DEV_FLUER = 'uploads.dev.fluer.com',
  UPLOADS_FLUER = 'uploads.fluer.com',
  VERSION_DEV_FLUER = 'version.dev.fluer.com',
  VERSION_FLUER = 'version.fluer.com',
  VIDEOEDITOR_BUILD_DESYGNER = 'videoeditor.builddesygner.xyz',
  VIDEOEDITOR_DESYGNER = 'videoeditor.desygner.com',
  VIDEOEDITOR_MAKE_DESYGNER = 'videoeditor.makedesygner.xyz',
  VIDEOEDITOR_QA_DESYGNER = 'videoeditor.qadesygner.xyz',
  VIDEOEDITOR_QC_DESYGNER = 'videoeditor.qcdesygner.xyz',
}
